import React from "react";

import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";

import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import {useTranslation} from "react-i18next";



const CardInfoList = () => {
    const {t} = useTranslation(['groups']);

    return <Card>
        <MDBox py={2} px={2}>
            <MDTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                {t('group.cardInfo.title')}
            </MDTypography>
            <Container maxWidth="md">
            </Container>
        </MDBox>
    </Card>
}

export default CardInfoList;